import { EllipsisVerticalIcon } from 'lucide-react';

import { Button } from '@nesso/ui/primitives/button';

import type { SelectedClient } from '@/entities/client';
import { openScheduleSession } from '@/features/session/schedule-session';
import { SheetClose, SheetCloseButton, SheetHeader } from '@/shared/ui/panels/sheet-panel';

type Props = {
    client: SelectedClient | undefined;
    disabled: boolean;
};

export function ClientDetailsActionBar({ client, disabled }: Props) {
    return (
        <SheetHeader variant="breadcrumbs" className="shrink-0 gap-2">
            <div className="flex items-center gap-2">
                <Button type="button" variant="outline" size="sm" disabled={disabled}>
                    New Chart Note
                </Button>
                <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    disabled={disabled || !client}
                    onClick={() => client && openScheduleSession(client)}
                >
                    New Session
                </Button>
            </div>
            <div className="flex items-center gap-2">
                <Button
                    type="button"
                    variant="ghost"
                    size="icon-sm"
                    aria-label="Chart options"
                    disabled={disabled}
                >
                    <EllipsisVerticalIcon className="size-4" />
                </Button>
                <SheetClose asChild>
                    <SheetCloseButton />
                </SheetClose>
            </div>
        </SheetHeader>
    );
}
